import { Injectable, OnDestroy } from '@angular/core'
import { CanMatch, UrlTree } from '@angular/router'
import { Observable } from 'rxjs'
import { FeatureFlagsService } from '../services/feature-flag.service'

@Injectable({ providedIn: 'root' })
export class ReadingsGuard implements CanMatch, OnDestroy {
  private isReadingsEnabled: boolean
  private subscriptions = [
    this.featureFlagsService.readings$.subscribe(({ isEnabled })=>{
      this.isReadingsEnabled = isEnabled
    })
  ]
  constructor (
    private featureFlagsService: FeatureFlagsService
  ){}
  ngOnDestroy ():void{
    this.subscriptions.forEach(((subscription)=>subscription.unsubscribe()))
  }
  canMatch (): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    return this.isReadingsEnabled
  }
}
